import React, { useEffect, useState } from "react";
import { getCookie, setCookie } from "../../src/utils/cookies";
const useDevControls = () => {
    const [language, setLanguage] = useState(getCookie("LV_language") || "lv");

    const [showOnlyLowestLevelAddresses, setShowOnlyLowestLevelAddresses] = useState(true);
    const [showAdditionalFilters, setShowAdditionalFilters] = useState(false);
    const [devControls, setDevControls] = useState(false);

    const [visibleColumnLabels, setVisibleColumnLabels] = useState(
        ["index","address","selectButton"]
    );
    const [visibleDataLabels, setVisibleDataLabels] = useState(
        [
            "address",
            "zipCode"
        ]
    );

    const availableDataLabels = [
        "code",
        "address",
        "zipCode",
        "type",
        "structure",
        "history",
        "lksLat",
        "lksLong",
        "all"
    ]

    const availableColumnLabels = [
        "index",
        "code",
        "address",
        "selectButton",
        "all"
    ]

    const availableLanguages = [
        "lv",
        "ru",
        "en"
    ]

    useEffect(() => {
        const event = new CustomEvent('lvlv.current_language_changed',{
            detail: {
                lang: language
            }
        });
        document.dispatchEvent(event);

        setCookie("LV_language", language)
    },[language])

    const Element = (
        <>
            <button
                onClick={()=>{
                    setDevControls(!devControls)
                }}
            >{devControls ? "hide dev controls" : "show dev controls"}</button>
            {devControls ? (
                <>
                    <div>
                        <div>
                            <div>
                                visibleColumnLabels (white selected, red unselected):
                            </div>
                            {availableColumnLabels.map((e,idx) => (
                                <button
                                    style={{
                                        background: visibleColumnLabels.includes(e) ? "#fff": "red",
                                        boxShadow: "none",
                                        outline: "none",
                                        border: "1px solid #000"
                                    }}
                                    key={idx}
                                    onClick={()=>{
                                        let newArr = [...visibleColumnLabels]
                                        const index = newArr.indexOf(e);
                                        if (index > -1) {
                                            newArr.splice(index, 1);
                                        } else {
                                            if (e === "all") {
                                                newArr = ["all"];
                                            } else {

                                                const allIndex = newArr.indexOf("all");

                                                if (allIndex > -1) {
                                                    newArr.splice(allIndex, 1);
                                                }

                                                newArr.push(e);
                                            }
                                        }

                                        setVisibleColumnLabels(newArr);
                                    }}
                                >
                                    {e}
                                </button>
                            ))}
                        </div>

                        <div style={{marginTop: "20px"}}>
                            <div>
                                visibleDataLabels (white selected, red unselected):
                            </div>
                            {availableDataLabels.map((e,idx) => (
                                <button
                                    style={{
                                        background: visibleDataLabels.includes(e) ? "#fff": "red",
                                        boxShadow: "none",
                                        outline: "none",
                                        border: "1px solid #000"
                                    }}
                                    key={idx}
                                    onClick={()=>{
                                        let newArr = [...visibleDataLabels]
                                        const index = newArr.indexOf(e);
                                        if (index > -1) {
                                            newArr.splice(index, 1);
                                        } else {
                                            if (e === "all") {
                                                newArr = ["all"];
                                            } else {

                                                const allIndex = newArr.indexOf("all");

                                                if (allIndex > -1) {
                                                    newArr.splice(allIndex, 1);
                                                }

                                                newArr.push(e);
                                            }
                                        }

                                        setVisibleDataLabels(newArr);
                                    }}
                                >
                                    {e}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div style={{marginTop: "20px"}}>
                        {availableLanguages.map((e,idx)=>(
                            <button key={idx} onClick={()=>{
                                setLanguage(e)
                            }}>change language to {e}</button>
                        ))}
                    </div>

                    <div>
                        <div>
                            <label htmlFor="showOnlyLowestLevelAddresses">
                                showOnlyLowestLevelAddresses:
                                <input type={"checkbox"} id={"showOnlyLowestLevelAddresses"} checked={showOnlyLowestLevelAddresses} onChange={(e)=>{
                                    setShowOnlyLowestLevelAddresses(e.target.checked)
                                }}/>
                            </label>
                        </div>
                        <div>
                            <label htmlFor="showAdditionalFilters">
                                showAdditionalFilters:
                                <input type={"checkbox"} id={"showAdditionalFilters"} checked={showAdditionalFilters} onChange={(e)=>{
                                    setShowAdditionalFilters(e.target.checked)
                                }}/>
                            </label>
                        </div>
                    </div>
                </>
            ) : ""}
        </>
    )

    return [Element, visibleColumnLabels, visibleDataLabels, showOnlyLowestLevelAddresses, showAdditionalFilters]
}

export default useDevControls;